var _defs, _rect, _mask, _use, _text, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaterials = function SvgMaterials(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.2%",
    y: "-3.5%",
    width: "100.3%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 240,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mockups---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-user-profile",
    transform: "translate(-1386.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    filter: "url(#filter-1)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "container",
    x: 0,
    y: 0,
    width: 1440,
    height: 72
  })), /*#__PURE__*/React.createElement("g", {
    id: "Profile-tab-",
    transform: "translate(1200.000000, 0.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "container",
    xlinkHref: "#path-2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Las-Americas-Group",
    mask: "url(#mask-3)",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 21,
    letterSpacing: -0.35,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 31
  }, "Sara Davila"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "materials-icon",
    opacity: 0.942871094
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icon-copy",
    fill: "#278ECD",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.533333, 9.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8592,1.39828584 L13.1018667,4.04948584 L10.2461333,6.44548584 L9.1504,7.38868584 L4.07813333,11.6702858 L1.83546667,9.01935251 L10.8592,1.39828584 Z M10.7570667,3.46281917 L3.49146667,9.52948584 L3.62,9.68201917 L10.9098667,3.64148584 L10.7570667,3.46281917 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6053333,1.65321917 L13.4584,0.302285841 C13.1773333,-0.0539808257 12.6434667,-0.104914159 12.2856,0.200685841 L11.2912,1.04175251 L13.5357333,3.69241917 L14.5034667,2.85161917 C14.86,2.54575251 14.9106667,2.01055251 14.6053333,1.65321917",
    id: "Fill-210",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-212",
    fill: "#FFFFFF",
    points: "-6.06329801e-14 12.8681525 3.49146667 12.0268192 1.4016 9.52948584 -6.06329801e-14 12.8681525"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaterials, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/materials.240b9cce.svg";
export { ForwardRef as ReactComponent };